import { AxiosResponse } from 'axios'
import axios from 'lib/axios'

export interface Test360ResponseTypes {
  report_title: string
  header_data: HeaderData
  scores: Scores
  competencies: string[]
  evaluator_details: EvaluatorDetail[]
}

export interface EvaluatorDetail {
  evaluator_name: string
  role_name: string
  status: string
  evaluator_user_test_id: number
  evaluator_email: string
  test_reminder: string
}

export interface HeaderData {
  company_name: string
  process_name: string
  process_id: string
  completion_date: string
  user_email: string
  test_reminder: string
}

export interface Scores {
  score_with_autoevaluation: number
  score_without_autoevaluation: number
  dissonance_value: number
  dissonance_text: string
}

export const fetchResults360 = async (userTestId: number) => {
  const PATH = `${process.env.REACT_APP_MAIN_API}/test360/detail/results/${userTestId}`

  try {
    const response: AxiosResponse<Test360ResponseTypes> = await axios.get(PATH)
    return response.data
  } catch (error) {
    throw new Error('Error fetching')
  }
}
